import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import NewsTicker from './components/NewsTicker';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Admissions from './pages/Admissions';
import Academics from './pages/Academics';
import Infrastructure from './pages/Infrastructure';
import Activities from './pages/Activities';
import Gallery from './pages/Gallery';
import Teachers from './pages/Teachers';
import News from './pages/News';
import Resources from './pages/Resources';
import Contact from './pages/Contact';
import PaymentSuccess from './pages/PaymentSuccess';
import './index.css';

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <NewsTicker />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/admissions" element={<Admissions />} />
                        <Route path="/academics" element={<Academics />} />
                        <Route path="/infrastructure" element={<Infrastructure />} />
                        <Route path="/activities" element={<Activities />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/teachers" element={<Teachers />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/resources" element={<Resources />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/payment-success" element={<PaymentSuccess />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsAppButton />
                <ScrollToTop />
                <Toaster position="top-right" richColors />
            </div>
        </BrowserRouter>
    );
}

export default App;
